import type { Machine, OverdueReturnBooking } from '../types';
import { isBookingOverdueReturn } from '../constants';
import { appNowTimestamp, toWallClockTimestamp } from '../../../utils/timezone';

// Finds every booking that's overdue for hand-in: pickup was confirmed, hand-in was not, and
// its own end_date/end_time has already elapsed. Pure and client-side, mirroring
// `computeRentalExtensionSuggestions` — fed the in-memory `machines` already loaded by
// `useMachines`, no direct Supabase access, `nowMs` injectable for testability.
export function computeOverdueReturnBookings(
  machines: Machine[],
  nowMs: number = appNowTimestamp()
): OverdueReturnBooking[] {
  const results: OverdueReturnBooking[] = [];

  machines.forEach((m) => {
    (m.bookings ?? []).forEach((bk) => {
      // Only ever called while pickupHandinEnabled is true (gated at the useDashboardChartData
      // call site) — the feature genuinely isn't meaningful otherwise.
      if (!isBookingOverdueReturn(bk, true, nowMs)) return;
      const end = toWallClockTimestamp(bk.end_date, bk.end_time)!;
      results.push({ booking: bk, machine: m, overdueByMs: nowMs - end });
    });
  });

  // Most overdue first — the ones needing the most urgent follow-up surface at the top.
  return results.sort((a, b) => b.overdueByMs - a.overdueByMs);
}
